import { BaseEntity } from '../base/BaseEntity'
import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop, PropType } from '@typegoose/typegoose'
import type { WorkOrderStatusEnum } from './WorkOrderStatusEnum'
import { Product } from '../product/Product'
import { RelatedEntity } from '../base/RelatedEntity'
import { Order } from '../order/Order'
import { InventoryBySerialNumber } from '../inventorybyserialnumber/InventoryBySerialNumber'
import { Project } from '../project/Project'
import { WorkOrderItem } from './WorkOrderItem'
import { Activity } from '../activity/Activity'
import { Logistic } from '../logistic/Logistic'
import { Task } from '../task/Task'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('WorkOrderInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class WorkOrder extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('wo') })
  declare _id: string

  @Field(() => Date)
  @Prop({ type: Date })
  completionDate: Date

  @Field(() => String)
  @Prop({ type: String })
  declare status: WorkOrderStatusEnum

  @Field(() => [Order])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  relatedSalesOrders: ReturnType<() => Order[]>

  @Field(() => [Logistic])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  relatedLogistics: ReturnType<() => Logistic[]>

  /**
   * If this work order requires sub-workOrder to complete, this field should show the which are work orders related to this
   */
  @Field(() => [WorkOrder])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  relatedWorkOrders: ReturnType<() => WorkOrder[]>

  @Field(() => [WorkOrderItem])
  @Prop({ type: [WorkOrderItem] }, PropType.ARRAY)
  items: ReturnType<() => WorkOrderItem[]>

  /**
   * The product for this work order is being focus to
   */
  @Field(() => Product)
  @Prop({ type: RelatedEntity })
  product: ReturnType<() => Product>

  /**
   * The number of items to be produce for this product
   */
  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  /**
   * Flag to determine if the workOrder order needs to be prioritized
   */
  @Field(() => Boolean)
  @Prop({ type: Boolean })
  prioritized: boolean

  @Field(() => [Task])
  @Prop({ type: [RelatedEntity] }, PropType.ARRAY)
  tasks: ReturnType<() => Task[]>

  @Field(() => [Activity])
  @Prop({ type: [Activity] })
  remarksActivity: Activity[]

  @Field(() => [InventoryBySerialNumber])
  @Prop({ type: () => [InventoryBySerialNumber] }, PropType.ARRAY)
  inventoryBySerialNumbers: ReturnType<() => InventoryBySerialNumber[]>

  /**
   * The following fields has fieldResovlers, we just need it here for type-safety
   */
  @Field(() => Float)
  progressNow: number

  @Field(() => Float)
  progressMax: number

  @Field(() => [Project])
  projects: Project[]

  @Field(() => Product)
  outOfStockProduct: ReturnType<() => Product>
}
